import { cn } from "@omni/utils/styles";

type BrandProps = {
    brandName: string | undefined;
    className?: string;
};

const Brand = ({ brandName, className }: BrandProps) => {
    if (!brandName) return null;

    return <div className={cn(className)}>{brandName}</div>;
};

export default Brand;
